import { withParams } from 'vuelidate/lib/validators/common'

const phoneNumber = new RegExp('^(\\+|\\d)[0-9]+$')

const phoneNumberValidation = withParams(
  { type: 'phoneNumber' },
  (value) => {
    return phoneNumber.test(value)
  }
)

export default phoneNumberValidation



// WEBPACK FOOTER //
// ./src/utils/validators/isPhoneNumber.js